// extracted by mini-css-extract-plugin
export default {"root":"LineBookingCard_root__QOdZ7","notes":"LineBookingCard_notes__AuBPV"};